import { ReactElement, FC } from 'react'

import { ButtonSize } from '../Buttons/types'
import Spinner from '../Spinner'

interface Iprops {
  isLoading: boolean
  size?: ButtonSize
  children: ReactElement
  color?: 'white' | 'purple'
  backgroundColor?: string
  className?: string
}

const Loader: FC<Iprops> = ({
  isLoading = true,
  children,
  size = 'small',
  color = 'purple',
  backgroundColor,
  className = '',
}) => {
  return isLoading ? (
    <Spinner backgroundColor={backgroundColor} className={className} color={color} size={size} />
  ) : (
    children
  )
}

export default Loader
